"use client";

import type {
  LeadFlowAnswers,
  LeadFlowDocument,
  LeadFlowStepItem,
} from "../types";

import { useEffect, useRef } from "react";
import { LeadFlowAnswerSnapshotProvider } from "./LeadFlowAnswerStoreProvider";
import { StepItems } from "./StepItems";
import { ThankYouIcon } from "./ThankYouIcon";

type ThankYouProps = {
  submittedAnswers: LeadFlowAnswers;
  thankYou: LeadFlowDocument["thankYou"];
};

/**
 * Shown after a successful submit, with the fixed success icon. Submit
 * clears the page store, so answer placeholders read the submitted answers.
 */
function ThankYou({ submittedAnswers, thankYou }: ThankYouProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    containerRef.current?.focus();
  }, []);

  return (
    <div
      className="flex w-full flex-col items-center gap-4 outline-none"
      data-lead-flow-thank-you=""
      ref={containerRef}
      tabIndex={-1}
    >
      <ThankYouIcon />
      {/* A readable column with space between consecutive paragraphs. */}
      <div className="flex w-full max-w-[560px] flex-col items-start gap-6 [&_p+p]:mt-2">
        <LeadFlowAnswerSnapshotProvider answers={submittedAnswers}>
          <StepItems items={(thankYou?.content ?? []) as LeadFlowStepItem[]} />
        </LeadFlowAnswerSnapshotProvider>
      </div>
    </div>
  );
}

export { ThankYou };
